import "./Links.css";

const Links = () => {
  return (
    <div className="links">
      <a className="underline" href="#item1">
        Photo #1
      </a>

      <a className="underline" href="#item2">
        Photo #2
      </a>
      <a className="underline" href="#item3">
        Photo #3
      </a>
    </div>
  );
};

export default Links;
